export enum EKwikUIInputPasswordSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputPasswordSize = [
  EKwikUIInputPasswordSize.S,
  EKwikUIInputPasswordSize.M,
  EKwikUIInputPasswordSize.L
] as const;

export type TKwikUIInputPasswordSize =
  (typeof VKwikUIInputPasswordSize)[number];
